import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import CustomAddButton from "@/common/components/custom/buttons/CustomAddButton";
import CustomTable from "@/common/components/custom/CustomTable";
import { useMutation } from "react-query";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { faAdd, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { findAllLanguages } from "@/api/query/language";
import AdminLanguageEdit from "./components/AdminLanguageEdit";
import AdminVoiceEdit from "./components/AdminVoiceEdit";
import moment from "moment";
import Loading from "@/common/components/Loading";
import { Color } from "@/common/colors/colors";

const TopContent = styled.div`
  display: flex;
  justify-content: right;
`;
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SectionTitle = styled.h3`
  color: ${Color.DarkBlue};
  margin: 0;
`;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LANGUAGE_HEADERS = ["No.", "Name", "Short name", "Created At", "Actions"];
const VOICE_HEADERS = [
  "No.",
  "Language",
  "Type",
  "Language code",
  "Voice name",
  "Gender",
  "Encoding",
  "Actions",
];

const AdminLanguagePage = () => {
  const [editLanguage, setEditLanguage] = useState();
  const [editVoice, setEditVoice] = useState();
  const [languages, setLanguages] = useState([]);
  const [tableData, setTableData] = useState();
  const [voiceTableData, setVoiceTableData] = useState();

  const findUsersMutation = useMutation({
    mutationFn: () => findAllLanguages(),
    onSuccess: ({ data }) => {
      setLanguages(data || []);
      setTableData(() =>
        data?.map((d, i) => [
          i + 1,
          d.name,
          d.shortName,
          moment(d.created_at).format("DD/MM/YYYY HH:mm"),
          <div style={{ display: "flex", gap: "10px" }}>
            <CustomEditButton
              onClick={() => setEditLanguage(d)}
              text={
                <FontAwesomeIcon icon={faEdit} style={{ color: "white" }} />
              }
            />
          </div>,
        ])
      );

      const voiceRows = [];
      data?.forEach((language) => {
        (language.voices || []).forEach((voice) => {
          voiceRows.push({ language, voice });
        });
      });

      setVoiceTableData(() =>
        voiceRows.map((row, i) => [
          i + 1,
          row.language.name,
          row.voice.type,
          row.voice.languageCode,
          row.voice.name,
          row.voice.ssmlGender,
          row.voice.audioEncoding,
          <div style={{ display: "flex", gap: "10px" }}>
            <CustomEditButton
              onClick={() => setEditVoice(row)}
              text={
                <FontAwesomeIcon icon={faEdit} style={{ color: "white" }} />
              }
            />
          </div>,
        ])
      );
    },
  });

  useEffect(() => {
    if (!editLanguage && !editVoice) {
      findUsersMutation.mutate();
    }
  }, [editLanguage, editVoice]);

  return (
    <>
      {findUsersMutation.isLoading && <Loading />}
      <Wrapper>
        {editLanguage && (
          <AdminLanguageEdit edit={editLanguage} setEdit={setEditLanguage} />
        )}
        {editVoice && (
          <AdminVoiceEdit
            edit={editVoice}
            setEdit={setEditVoice}
            languages={languages}
          />
        )}
        <SectionHeader>
          <SectionTitle>Languages</SectionTitle>
          <TopContent>
            <CustomAddButton
              onClick={() => setEditLanguage({})}
              text={<FontAwesomeIcon icon={faAdd} style={{ color: "white" }} />}
            />
          </TopContent>
        </SectionHeader>
        <CustomTable headers={LANGUAGE_HEADERS} data={tableData} />
        <SectionHeader>
          <SectionTitle>Voice configs</SectionTitle>
          <TopContent>
            <CustomAddButton
              onClick={() => setEditVoice({})}
              text={<FontAwesomeIcon icon={faAdd} style={{ color: "white" }} />}
            />
          </TopContent>
        </SectionHeader>
        <CustomTable headers={VOICE_HEADERS} data={voiceTableData} />
      </Wrapper>
    </>
  );
};

export default AdminLanguagePage;
